'use strict';

angular.module('referrals').directive('referralAccessCodes', [function () {
  return {
    templateUrl: 'referrals/templates/accessCode.html',
    replace: false,
    restrict: 'EA',
    scope: {
      accessCodeChoice: '=accessCodeChoice',
      accessCodes: '=referralAccessCodes',
      accessCodeType: '=referralAccessCodeType',
      accessCodeLabel: '=referralAccessCodeLabel',
      accessCodeHelpToolTip: '=referralAccessCodeHelpToolTip',
      enabled: '=referralAccessCodesEnabled',
      form: '='
    }
  };
}]);